import React, { useState, useRef, useEffect } from 'react';

interface SliderProps {
  value: number[];
  max: number;
  step?: number;
  disabled?: boolean;
  className?: string;
  onChange?: (value: number[]) => void;
}

const Slider = ({ 
  value, 
  max, 
  step = 1, 
  disabled = false, 
  className = '',
  onChange
}: SliderProps) => {
  const [sliderValue, setSliderValue] = useState(value[0] || 0);
  const sliderRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    setSliderValue(value[0] || 0);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(e.target.value);
    setSliderValue(newValue);
    if (onChange) {
      onChange([newValue]);
    }
  };

  const percentage = (sliderValue / max) * 100;
  
  return (
    <div className={`relative w-full ${className}`}>
      <div 
        ref={sliderRef}
        className="h-2 w-full overflow-hidden rounded-full bg-gray-200"
      >
        <div 
          className="h-full bg-primary transition-all" 
          style={{ width: `${percentage}%` }}
        />
      </div>
      <input
        type="range"
        min={0}
        max={max}
        step={step}
        value={sliderValue}
        disabled={disabled}
        onChange={handleChange}
        className="absolute inset-0 h-2 w-full cursor-pointer appearance-none opacity-0 disabled:cursor-not-allowed"
      />
    </div>
  );
};

export default Slider;
